import React from 'react';
import { useNavigate } from 'react-router-dom';
import Emergency from '../screens/Emergency';


export default function EmergencyContainer(props) {
    let navigate = useNavigate();

    return <Emergency {...props} />
}